__turbopack_context__.v({
  "article": "_3T1jZW_article",
  "button": "_3T1jZW_button",
  "textContainer": "_3T1jZW_textContainer",
  "title": "_3T1jZW_title",
});
